import { render } from "./FinisciRilevazione.vue?vue&type=template&id=ba0b94ea&scoped=true"
import script from "./FinisciRilevazione.vue?vue&type=script&lang=js"
export * from "./FinisciRilevazione.vue?vue&type=script&lang=js"

import "./FinisciRilevazione.vue?vue&type=style&index=0&id=ba0b94ea&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba0b94ea"]])

export default __exports__